module.exports = __webpack_public_path__ + "static/4-6da5452418b97abdb26a380afe74056c.jpg";